<mat-tab-group>
  <mat-tab label="Detail">
    <sign-detail
      [sign]="signCopy"
      (signSaved)="onSignSaved($event)"
    ></sign-detail>
  </mat-tab>
  <mat-tab *ngIf="sign && sign.id != null" label="Stock">
    <stock-for-sign
      [sign]="sign"
      (roofLocationChanged)="onRoofLocationChanged($event)"
      (recupMethodChanged)="onRecupMethodChanged($event)"
    ></stock-for-sign>
  </mat-tab>
  <mat-tab *ngIf="sign && sign.id != null" label="Titels/Telnrs/Stickers">
    <sign-associations-overview [sign]="sign"></sign-associations-overview>
  </mat-tab>
</mat-tab-group>
